import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, PieChart, Pie } from "recharts";
import "katex/dist/katex.min.css";
import { BlockMath, InlineMath } from "react-katex";
import { renderWithLatex } from "../utils/latexRenderer";

const API_BASE = "https://eluvent.com/api";

// ==================== MD5 (unchanged) ====================
function md5(str) {
  function md5cycle(x, k) {
    var a = x[0], b = x[1], c = x[2], d = x[3];
    a = ff(a, b, c, d, k[0], 7, -680876936);
    d = ff(d, a, b, c, k[1], 12, -389564586);
    c = ff(c, d, a, b, k[2], 17, 606105819);
    b = ff(b, c, d, a, k[3], 22, -1044525330);
    a = ff(a, b, c, d, k[4], 7, -176418897);
    d = ff(d, a, b, c, k[5], 12, 1200080426);
    c = ff(c, d, a, b, k[6], 17, -1473231341);
    b = ff(b, c, d, a, k[7], 22, -45705983);
    a = ff(a, b, c, d, k[8], 7, 1770035416);
    d = ff(d, a, b, c, k[9], 12, -1958414417);
    c = ff(c, d, a, b, k[10], 17, -42063);
    b = ff(b, c, d, a, k[11], 22, -1990404162);
    a = ff(a, b, c, d, k[12], 7, 1804603682);
    d = ff(d, a, b, c, k[13], 12, -40341101);
    c = ff(c, d, a, b, k[14], 17, -1502002290);
    b = ff(b, c, d, a, k[15], 22, 1236535329);
    a = gg(a, b, c, d, k[1], 5, -165796510);
    d = gg(d, a, b, c, k[6], 9, -1069501632);
    c = gg(c, d, a, b, k[11], 14, 643717713);
    b = gg(b, c, d, a, k[0], 20, -373897302);
    a = gg(a, b, c, d, k[5], 5, -701558691);
    d = gg(d, a, b, c, k[10], 9, 38016083);
    c = gg(c, d, a, b, k[15], 14, -660478335);
    b = gg(b, c, d, a, k[4], 20, -405537848);
    a = gg(a, b, c, d, k[9], 5, 568446438);
    d = gg(d, a, b, c, k[14], 9, -1019803690);
    c = gg(c, d, a, b, k[3], 14, -187363961);
    b = gg(b, c, d, a, k[8], 20, 1163531501);
    a = gg(a, b, c, d, k[13], 5, -1444681467);
    d = gg(d, a, b, c, k[2], 9, -51403784);
    c = gg(c, d, a, b, k[7], 14, 1735328473);
    b = gg(b, c, d, a, k[12], 20, -1926607734);
    a = hh(a, b, c, d, k[5], 4, -378558);
    d = hh(d, a, b, c, k[8], 11, -2022574463);
    c = hh(c, d, a, b, k[11], 16, 1839030562);
    b = hh(b, c, d, a, k[14], 23, -35309556);
    a = hh(a, b, c, d, k[1], 4, -1530992060);
    d = hh(d, a, b, c, k[4], 11, 1272893353);
    c = hh(c, d, a, b, k[7], 16, -155497632);
    b = hh(b, c, d, a, k[10], 23, -1094730640);
    a = hh(a, b, c, d, k[13], 4, 681279174);
    d = hh(d, a, b, c, k[0], 11, -358537222);
    c = hh(c, d, a, b, k[3], 16, -722521979);
    b = hh(b, c, d, a, k[6], 23, 76029189);
    a = hh(a, b, c, d, k[9], 4, -640364487);
    d = hh(d, a, b, c, k[12], 11, -421815835);
    c = hh(c, d, a, b, k[15], 16, 530742520);
    b = hh(b, c, d, a, k[2], 23, -995338651);
    a = ii(a, b, c, d, k[0], 6, -198630844);
    d = ii(d, a, b, c, k[7], 10, 1126891415);
    c = ii(c, d, a, b, k[14], 15, -1416354905);
    b = ii(b, c, d, a, k[5], 21, -57434055);
    a = ii(a, b, c, d, k[12], 6, 1700485571);
    d = ii(d, a, b, c, k[3], 10, -1894986606);
    c = ii(c, d, a, b, k[10], 15, -1051523);
    b = ii(b, c, d, a, k[1], 21, -2054922799);
    a = ii(a, b, c, d, k[8], 6, 1873313359);
    d = ii(d, a, b, c, k[15], 10, -30611744);
    c = ii(c, d, a, b, k[6], 15, -1560198380);
    b = ii(b, c, d, a, k[13], 21, 1309151649);
    a = ii(a, b, c, d, k[4], 6, -145523070);
    d = ii(d, a, b, c, k[11], 10, -1120210379);
    c = ii(c, d, a, b, k[2], 15, 718787259);
    b = ii(b, c, d, a, k[9], 21, -343485551);
    x[0] = add32(a, x[0]);
    x[1] = add32(b, x[1]);
    x[2] = add32(c, x[2]);
    x[3] = add32(d, x[3]);
  }
  function cmn(q, a, b, x, s, t) {
    a = add32(add32(a, q), add32(x, t));
    return add32((a << s) | (a >>> (32 - s)), b);
  }
  function ff(a, b, c, d, x, s, t) { return cmn((b & c) | ((~b) & d), a, b, x, s, t); }
  function gg(a, b, c, d, x, s, t) { return cmn((b & d) | (c & (~d)), a, b, x, s, t); }
  function hh(a, b, c, d, x, s, t) { return cmn(b ^ c ^ d, a, b, x, s, t); }
  function ii(a, b, c, d, x, s, t) { return cmn(c ^ (b | (~d)), a, b, x, s, t); }
  function md51(s) {
    var n = s.length,
      state = [1732584193, -271733879, -1732584194, 271733878],
      i, length, tail, tmp, lo, hi;
    for (i = 64; i <= n; i += 64) md5cycle(state, md5blk(s.substring(i - 64, i)));
    s = s.substring(i - 64);
    length = s.length;
    tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (i = 0; i < length; i++) tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
    tail[i >> 2] |= 0x80 << ((i % 4) << 3);
    if (i > 55) { md5cycle(state, tail); for (i = 0; i < 16; i++) tail[i] = 0; }
    tmp = n * 8;
    tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
    lo = parseInt(tmp[2], 16);
    hi = parseInt(tmp[1], 16) || 0;
    tail[14] = lo;
    tail[15] = hi;
    md5cycle(state, tail);
    return state;
  }
  function md5blk(s) {
    var md5blks = [], i;
    for (i = 0; i < 64; i += 4) md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
    return md5blks;
  }
  var hex_chr = '0123456789abcdef'.split('');
  function rhex(n) { var s = '', j = 0; for (; j < 4; j++) s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F]; return s; }
  function hex(x) { for (var i = 0; i < x.length; i++) x[i] = rhex(x[i]); return x.join(''); }
  function add32(a, b) { return (a + b) & 0xFFFFFFFF; }
  if (typeof str === 'string') return hex(md51(str));
  return '';
}

// ==================== Component ====================
const BoardSimulatorPremium = () => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [board, setBoard] = useState("");
  const [subject, setSubject] = useState("");
  const [difficulty, setDifficulty] = useState("normal");
  const [includeCBQs, setIncludeCBQs] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paper, setPaper] = useState(null);
  const [answers, setAnswers] = useState({});
  const [flagged, setFlagged] = useState({});
  const [currentSection, setCurrentSection] = useState(0);
  const [timer, setTimer] = useState(0);
  const timerRef = useRef(null);
  const [screen, setScreen] = useState("setup");
  const [report, setReport] = useState(null);

  const boardSubjects = {
    CBSE: [
      { code: "science", name: "Science" },
      { code: "mathematics", name: "Mathematics" }
    ],
    ICSE: [
      { code: "physics", name: "Physics" },
      { code: "chemistry", name: "Chemistry" },
      { code: "biology", name: "Biology" },
      { code: "mathematics", name: "Mathematics" }
    ]
  };

  const subjects = board ? (boardSubjects[board] || []) : [];

  // Check authentication on mount
  useEffect(() => {
    axios.get(`${API_BASE}/auth/user`, { withCredentials: true })
      .then(res => {
        if (res.data && res.data.id) {
          setUser(res.data);
        }
      })
      .catch(() => {})
      .finally(() => setAuthLoading(false));
  }, []);

  useEffect(() => {
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, []);

  const startExam = async () => {
    if (!board || !subject) return setError("Select board and subject.");
    setLoading(true);
    setError(null);
    let finalSubject = subject;
    if (board === "CBSE" && ["physics", "chemistry", "biology"].includes(finalSubject)) {
      finalSubject = "science";
    }
    try {
      const res = await axios.post(`${API_BASE}/simulator/generate`, {
        board,
        subject: finalSubject,
        difficulty_mode: difficulty,
        include_cbqs: includeCBQs
      }, { withCredentials: true });
      if (!res.data.sections || res.data.sections.length === 0) throw new Error("Empty paper");
      setPaper(res.data);
      setTimer(res.data.time_minutes * 60);
      setScreen("exam");
      timerRef.current = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) { clearInterval(timerRef.current); handleSubmit(); return 0; }
          return prev - 1;
        });
      }, 1000);
    } catch (e) {
      setError(e.response?.data?.error || "Failed to generate paper.");
    } finally {
      setLoading(false);
    }
  };

  const selectAnswer = (sectionIdx, questionIdx, option) =>
    setAnswers(prev => ({ ...prev, [`${sectionIdx}-${questionIdx}`]: option }));
  const toggleFlag = (sectionIdx, questionIdx) =>
    setFlagged(prev => ({ ...prev, [`${sectionIdx}-${questionIdx}`]: !prev[`${sectionIdx}-${questionIdx}`] }));

  const handleSubmit = async () => {
    if (timerRef.current) clearInterval(timerRef.current);
    const timeTaken = paper.time_minutes * 60 - timer;
    const answerArray = [];
    paper.sections.forEach((sec, sIdx) => {
      sec.questions.forEach((q, qIdx) => {
        const key = `${sIdx}-${qIdx}`;
        const userAns = answers[key] || null;
        const raw = q.question || q.statement_a || q.scenario || "";
        const qHash = md5(raw);
        answerArray.push({ question_hash: qHash, user_answer: userAns });
      });
    });
    try {
      const res = await axios.post(`${API_BASE}/simulator/submit/${paper.paper_id}`, {
        answers: answerArray,
        time_taken_seconds: timeTaken
      }, { withCredentials: true });
      const reportRes = await axios.get(`${API_BASE}/simulator/report/${res.data.report_id}`, { withCredentials: true });
      setReport(reportRes.data);
      setScreen("report");
    } catch (e) {
      setError("Submission failed.");
    }
  };

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  // ========== AUTH LOADING / NOT AUTHENTICATED ==========
  if (authLoading) {
    return (
      <div style={{ textAlign: "center", padding: 60, fontFamily: "Nunito, sans-serif" }}>
        <p>Checking authentication…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ maxWidth: 560, margin: "60px auto", textAlign: "center", fontFamily: "Nunito, sans-serif" }}>
        <div style={{ background: "white", borderRadius: 24, padding: 40, boxShadow: "0 8px 30px rgba(0,0,0,0.08)" }}>
          <h2 style={{ fontSize: 28, fontWeight: 800, color: "#1e293b", marginBottom: 16 }}>🔐 Premium Board Simulator</h2>
          <p style={{ color: "#64748b", fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
            Sign in with your Google account to access full‑length, timed board exams with instant scoring and AI‑powered feedback.
          </p>
          <a
            href="https://eluvent.com/auth/google/login"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              padding: "14px 32px",
              background: "white",
              color: "#1e293b",
              border: "2px solid #e2e8f0",
              borderRadius: 16,
              fontWeight: 700,
              fontSize: 16,
              textDecoration: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              cursor: "pointer"
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Sign in with Google
          </a>
          <p style={{ marginTop: 20, fontSize: 12, color: "#94a3b8" }}>
            Your progress will be saved and you can take unlimited mock tests.
          </p>
        </div>
      </div>
    );
  }

  // ========== SETUP ==========
  if (screen === "setup") {
    return (
      <div style={{ maxWidth: 560, margin: "40px auto", padding: "0 16px", fontFamily: "Nunito, sans-serif" }}>
        <div style={{ background: "white", borderRadius: 24, padding: 32, boxShadow: "0 8px 30px rgba(0,0,0,0.05)" }}>
          {/* ===== SUCCESS BANNER ===== */}
          {window.location.search.includes('login=success') && (
            <div style={{
              background: "#d1fae5",
              border: "1px solid #6ee7b7",
              borderRadius: 12,
              padding: "12px 16px",
              marginBottom: 20,
              color: "#065f46",
              fontSize: 14,
              fontWeight: 600,
              textAlign: "center"
            }}>
              ✅ Login successful! Welcome, {user.name || user.email}.<br />
              You can now take unlimited mock tests. Your progress will be saved.
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <h2 style={{ fontSize: 28, fontWeight: 800, color: "#1e293b", margin: 0 }}>📝 Board Exam Simulator</h2>
            <span style={{ fontSize: 13, color: "#64748b" }}>
              👋 {user.name || user.email}
              <button
                onClick={() => {
                  axios.get(`${API_BASE}/auth/logout`, { withCredentials: true })
                    .then(() => setUser(null))
                    .catch(() => setUser(null));
                }}
                style={{
                  marginLeft: 10,
                  padding: "4px 12px",
                  background: "transparent",
                  border: "1px solid #e2e8f0",
                  borderRadius: 20,
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b"
                }}
              >Logout</button>
            </span>
          </div>

          <p style={{ color: "#64748b", fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
            Take a full‑length, timed board exam on your screen. All questions are objective for instant scoring.
          </p>

          <label style={{ fontWeight: 600, fontSize: 14, color: "#1e293b", marginBottom: 6, display: "block" }}>📚 Select Board</label>
          <select value={board} onChange={e => setBoard(e.target.value)} style={{ width: "100%", padding: 12, borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 16, marginBottom: 20, background: "white" }}>
            <option value="">-- Select Board --</option>
            <option value="CBSE">CBSE</option>
            <option value="ICSE">ICSE</option>
          </select>

          <label style={{ fontWeight: 600, fontSize: 14, color: "#1e293b", marginBottom: 6, display: "block" }}>📖 Select Subject</label>
          <select value={subject} onChange={e => setSubject(e.target.value)} style={{ width: "100%", padding: 12, borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 16, marginBottom: 20, background: "white" }}>
            <option value="">-- Select Subject --</option>
            {subjects.map(s => <option key={s.code} value={s.code}>{s.name}</option>)}
          </select>

          <label style={{ fontWeight: 600, fontSize: 14, color: "#1e293b", marginBottom: 6, display: "block" }}>⚡ Difficulty</label>
          <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
            {["easy", "normal", "hard"].map(level => (
              <button key={level} onClick={() => setDifficulty(level)}
                style={{
                  flex: 1, padding: "10px 0", borderRadius: 12, fontWeight: 700, fontSize: 14,
                  border: difficulty === level ? "2px solid #7c3aed" : "1px solid #e2e8f0",
                  background: difficulty === level ? "#ede9fe" : "white",
                  color: difficulty === level ? "#7c3aed" : "#475569", cursor: "pointer"
                }}
              >{level.charAt(0).toUpperCase() + level.slice(1)}</button>
            ))}
          </div>

          <label style={{ fontWeight: 600, fontSize: 14, color: "#1e293b", display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
            <input type="checkbox" checked={includeCBQs} onChange={e => setIncludeCBQs(e.target.checked)} />
            ✅ Include Competency‑Based Questions (CBQs)
          </label>

          {error && <p style={{ color: "#dc2626", fontSize: 14, marginBottom: 16 }}>{error}</p>}

          <button onClick={startExam} disabled={!board || !subject || loading}
            style={{
              width: "100%", padding: 16, background: (!board || !subject) ? "#cbd5e1" : "linear-gradient(135deg, #fca311, #ff8c42)",
              color: "white", border: "none", borderRadius: 16, fontWeight: 700, fontSize: 18,
              cursor: (!board || !subject) ? "not-allowed" : "pointer", boxShadow: "0 6px 20px rgba(252, 163, 17, 0.35)"
            }}
          >
            {loading ? "⏳ Generating Paper… (may take 2‑3 minutes)" : "🚀 Start Test"}
          </button>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 15 }}>
            <Link to="/" style={{ color: "#64748b", fontSize: 14, textDecoration: "none" }}>← Back to Chat</Link>
            <Link to="/past-exams" style={{ color: "#7c3aed", fontSize: 14, fontWeight: 600, textDecoration: "none" }}>📊 My Past Exams</Link>
          </div>
        </div>
      </div>
    );
  }

  // ========== EXAM ==========
  if (screen === "exam" && paper) {
    const section = paper.sections[currentSection];
    const answeredCount = Object.keys(answers).length;
    const flaggedCount = Object.values(flagged).filter(Boolean).length;
    const totalQuestions = paper.sections.reduce((acc, sec) => acc + sec.questions.length, 0);
    return (
      <div style={{ maxWidth: 960, margin: "0 auto", padding: 20, fontFamily: "Nunito, sans-serif", background: "#f8fafc", minHeight: "100vh" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
          <div>
            <h1 style={{ fontSize: 22, margin: 0, color: "#1e293b" }}>📝 {paper.board} {paper.subject}</h1>
            <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>{paper.cbq_percentage}% CBQs • {paper.total_marks} marks</p>
          </div>
          <div style={{ background: timer < 600 ? "#fee2e2" : "#f0f9ff", padding: "12px 20px", borderRadius: 16, fontWeight: 700, fontSize: 22, color: timer < 600 ? "#dc2626" : "#1e40af" }}>
            ⏱️ {formatTime(timer)}
          </div>
        </div>
        <div style={{ display: "flex", gap: 16, marginBottom: 16, fontSize: 13, color: "#475569", flexWrap: "wrap" }}>
          <span>✅ {answeredCount}/{totalQuestions} answered</span>
          <span>🚩 {flaggedCount} flagged</span>
        </div>
        <div style={{ display: "flex", gap: 8, marginBottom: 24, overflowX: "auto" }}>
          {paper.sections.map((sec, idx) => (
            <button key={idx} onClick={() => setCurrentSection(idx)}
              style={{
                padding: "8px 16px", borderRadius: 20, border: currentSection === idx ? "2px solid #7c3aed" : "1px solid #e2e8f0",
                background: currentSection === idx ? "#ede9fe" : "white", color: currentSection === idx ? "#7c3aed" : "#475569",
                fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", cursor: "pointer"
              }}
            >{sec.title.split(" – ")[0]}</button>
          ))}
        </div>
        {section.questions.map((q, qi) => {
          const key = `${currentSection}-${qi}`;
          const userAns = answers[key] || null;
          return (
            <div key={qi} style={{ background: "white", borderRadius: 16, padding: 20, marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.04)", border: userAns ? "2px solid #7c3aed" : "1px solid #e2e8f0" }}>
              <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                <span style={{ background: "#e0f2fe", color: "#0369a1", padding: "2px 10px", borderRadius: 12, fontSize: 11, fontWeight: 700 }}>
                  {q.type === "assertion_reason" ? "Assertion‑Reason" : q.type === "case_based" ? "Case‑Based" : "MCQ"}
                </span>
                <span style={{ fontSize: 12, color: "#64748b" }}>{q.marks} mark{q.marks > 1 ? "s" : ""}</span>
                <button onClick={() => toggleFlag(currentSection, qi)} style={{ marginLeft: "auto", background: "none", border: "none", cursor: "pointer", fontSize: 18 }}>{flagged[key] ? "🚩" : "🏳️"}</button>
              </div>
              {q.type === "mcq" || !q.type ? (
                <div>
                  <p style={{ fontWeight: 600, margin: "0 0 12px 0" }}>{qi + 1}. {renderWithLatex(q.question)}</p>
                  {Object.entries(q.options || {}).map(([opt, text]) => (
                    <label key={opt} style={{
                      display: "block", margin: "6px 0", padding: "10px 14px", borderRadius: 10,
                      background: userAns === opt ? "#ede9fe" : "transparent",
                      border: userAns === opt ? "2px solid #7c3aed" : "1px solid #e2e8f0", cursor: "pointer"
                    }}>
                      <input type="radio" name={key} value={opt} checked={userAns === opt} onChange={() => selectAnswer(currentSection, qi, opt)} style={{ marginRight: 8 }} />
                      {opt.toUpperCase()}. {renderWithLatex(text)}
                    </label>
                  ))}
                </div>
              ) : q.type === "assertion_reason" ? (
                <div>
                  <p style={{ fontWeight: 600 }}>{qi + 1}. <span style={{ fontWeight: "normal" }}>Read the statements below:</span></p>
                  <div style={{ background: "#f8fafc", borderRadius: 10, padding: 14, margin: "8px 0" }}>
                    <p><strong>Assertion (A):</strong> {renderWithLatex(q.statement_a || q.question)}</p>
                    <p><strong>Reason (R):</strong> {renderWithLatex(q.statement_r)}</p>
                  </div>
                  {["a", "b", "c", "d"].map(opt => (
                    <label key={opt} style={{
                      display: "block", margin: "4px 0", padding: "8px 12px", borderRadius: 8,
                      background: userAns === opt ? "#ede9fe" : "transparent",
                      border: userAns === opt ? "2px solid #7c3aed" : "1px solid #e2e8f0", cursor: "pointer"
                    }}>
                      <input type="radio" name={key} value={opt} checked={userAns === opt} onChange={() => selectAnswer(currentSection, qi, opt)} style={{ marginRight: 8 }} />
                      {opt.toUpperCase()}
                    </label>
                  ))}
                </div>
              ) : q.type === "case_based" ? (
                <div>
                  <div style={{ background: "#f0f9ff", borderRadius: 10, padding: 14, marginBottom: 12, borderLeft: "4px solid #0ea5e9" }}>
                    <p><strong>📋 Scenario:</strong> {renderWithLatex(q.scenario || q.question)}</p>
                  </div>
                  {q.sub_questions && q.sub_questions.map((sub, idx) => {
                    const subKey = `${key}-sub-${idx}`;
                    const subAns = answers[subKey] || null;
                    return (
                      <div key={idx} style={{ marginBottom: 12 }}>
                        <p style={{ fontWeight: 600, fontSize: 14 }}>({String.fromCharCode(97 + idx)}) {renderWithLatex(sub.question)}</p>
                        {Object.entries(sub.options || {}).map(([opt, text]) => (
                          <label key={opt} style={{
                            display: "block", margin: "3px 0", padding: "6px 10px", borderRadius: 8,
                            background: subAns === opt ? "#ede9fe" : "transparent",
                            border: subAns === opt ? "2px solid #7c3aed" : "1px solid #e2e8f0", cursor: "pointer"
                          }}>
                            <input type="radio" name={subKey} value={opt} checked={subAns === opt} onChange={() => setAnswers(prev => ({ ...prev, [subKey]: opt }))} style={{ marginRight: 8 }} />
                            {opt.toUpperCase()}. {renderWithLatex(text)}
                          </label>
                        ))}
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          );
        })}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24, flexWrap: "wrap", gap: 10 }}>
          <button onClick={() => setCurrentSection(Math.max(0, currentSection - 1))} disabled={currentSection === 0}
            style={{ padding: "12px 24px", borderRadius: 30, border: "1px solid #e2e8f0", background: currentSection === 0 ? "#f1f5f9" : "white", color: currentSection === 0 ? "#94a3b8" : "#1e293b", fontWeight: 600, cursor: currentSection === 0 ? "not-allowed" : "pointer" }}
          >← Previous</button>
          {currentSection < paper.sections.length - 1 ? (
            <button onClick={() => setCurrentSection(currentSection + 1)}
              style={{ padding: "12px 24px", borderRadius: 30, border: "none", background: "linear-gradient(135deg, #7c3aed, #a78bfa)", color: "white", fontWeight: 700, cursor: "pointer" }}
            >Next →</button>
          ) : (
            <button onClick={handleSubmit}
              style={{ padding: "12px 32px", borderRadius: 30, border: "none", background: "linear-gradient(135deg, #10b981, #059669)", color: "white", fontWeight: 700, fontSize: 16, cursor: "pointer", boxShadow: "0 4px 15px rgba(16,185,129,0.4)" }}
            >✅ Submit Exam</button>
          )}
        </div>
      </div>
    );
  }

  // ========== REPORT ==========
  if (screen === "report" && report) {
    const chapterData = report.chapter_breakdown.map(ch => ({ name: ch.chapter, Accuracy: ch.accuracy, Marks: ch.scored_marks }));
    const readiness = report.readiness_score || 0;
    return (
      <div style={{ maxWidth: 960, margin: "40px auto", padding: "0 16px", fontFamily: "Nunito, sans-serif" }}>
        <div style={{ background: "white", borderRadius: 24, padding: 32, boxShadow: "0 8px 30px rgba(0,0,0,0.05)" }}>
          <h2 style={{ fontSize: 28, fontWeight: 800, color: "#1e293b", marginBottom: 8 }}>📊 Exam Report</h2>
          <p style={{ color: "#64748b", marginBottom: 24 }}>{report.board} {report.subject} • {report.total_marks} marks</p>
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginBottom: 32 }}>
            <div style={{ flex: 1, minWidth: 200, background: "#f0f9ff", borderRadius: 16, padding: 20, textAlign: "center" }}>
              <p style={{ fontSize: 14, color: "#475569" }}>Score</p>
              <p style={{ fontSize: 36, fontWeight: 800, color: "#1e40af", margin: "4px 0" }}>{report.score}/{report.total_marks}</p>
              <p style={{ fontSize: 16, fontWeight: 600, color: "#1e40af" }}>{report.percentage}%</p>
            </div>
            <div style={{ flex: 1, minWidth: 200, background: "#f0fdf4", borderRadius: 16, padding: 20, textAlign: "center" }}>
              <p style={{ fontSize: 14, color: "#475569" }}>Time Taken</p>
              <p style={{ fontSize: 28, fontWeight: 700, color: "#166534", margin: "8px 0" }}>{Math.floor(report.time_taken_seconds / 60)}m {report.time_taken_seconds % 60}s</p>
            </div>
            <div style={{ flex: 1, minWidth: 200, background: "#fef9c7", borderRadius: 16, padding: 20, textAlign: "center" }}>
              <p style={{ fontSize: 14, color: "#475569" }}>Readiness</p>
              <ResponsiveContainer width="100%" height={80}>
                <PieChart>
                  <Pie data={[{ name: "Ready", value: readiness }, { name: "Gap", value: 100 - readiness }]} cx="50%" cy="50%" innerRadius={25} outerRadius={35} startAngle={90} endAngle={-270} dataKey="value">
                    <Cell fill="#7c3aed" /><Cell fill="#e2e8f0" />
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div style={{ textAlign: "center", fontWeight: 800, color: "#7c3aed", marginTop: -40 }}>{readiness}%</div>
            </div>
          </div>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>📈 Chapter‑wise Accuracy</h3>
          <div style={{ width: "100%", height: 250, marginBottom: 32 }}>
            <ResponsiveContainer>
              <BarChart data={chapterData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                <YAxis domain={[0, 100]} />
                <Tooltip />
                <Bar dataKey="Accuracy" fill="#7c3aed" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: "#1e293b", marginBottom: 16 }}>🔍 Question Review</h3>
          {report.questions.map((q, idx) => (
            <div key={idx} style={{ border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, marginBottom: 12, background: q.is_correct ? "#f0fdf4" : "#fff7ed" }}>
              <p style={{ fontWeight: 600, margin: "0 0 8px 0", color: "#1e293b" }}>{idx + 1}. {renderWithLatex(q.question)}</p>
              <p style={{ fontSize: 13, color: "#475569", margin: "4px 0" }}>
                Your answer: <strong style={{ color: q.is_correct ? "#166534" : "#dc2626" }}>{q.user_answer || "Not answered"}</strong>
                {" | "}Correct: <strong>{q.correct_answer}</strong>
                {" | "}Marks: {q.marks}
                {" | "}{q.is_correct ? "✅ Correct" : "❌ Incorrect"}
              </p>
            </div>
          ))}
          <div style={{ textAlign: "center", marginTop: 32, background: "#fef9c7", borderRadius: 16, padding: 24 }}>
            <p style={{ fontSize: 16, fontWeight: 600, color: "#92400e", marginBottom: 12 }}>Your progress is saved. Keep practicing!</p>
          </div>
          <div style={{ textAlign: "center", marginTop: 24 }}>
            <button onClick={() => { setScreen("setup"); setPaper(null); setReport(null); }}
              style={{ padding: "12px 28px", borderRadius: 30, border: "none", background: "linear-gradient(135deg, #fca311, #ff8c42)", color: "white", fontWeight: 700, fontSize: 16, cursor: "pointer" }}
            >🔄 Take Another Test</button>
            <div style={{ marginTop: 16 }}>
              <Link to="/past-exams" style={{ color: "#7c3aed", fontWeight: 700, textDecoration: "none", fontSize: 14 }}>
                📊 View My Past Exams
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default BoardSimulatorPremium;